module.exports = __webpack_public_path__ + "mer/fonts/iconfont.5aec0249.woff";